// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-form-item--mini.el-form-item[data-v-3a5dfc90] {\n  margin: 15px 0;\n}\n[data-v-3a5dfc90] .el-table .warning-row{\n  color: red!important;\n}\n", ""]);
// Exports
module.exports = exports;
